import React from 'react'

const EmployeeTimeOff = () => {
  return (
    <div>EmployeeTimeOff</div>
  )
}

export default EmployeeTimeOff